import { http, HttpResponse } from 'msw';

import { apiRoutes } from '@features/campaigns/builder/consts/apiRoutes';
import { DataStatuses } from '@shared/types/common.ts';

export const creativesRequests = [
  http.delete(`*${apiRoutes.creativeLShapeImage(':id')}`, () => {
    return HttpResponse.json();
  }),
  http.delete(`*${apiRoutes.creativeLandingImage(':id')}`, () => {
    return HttpResponse.json();
  }),
  http.delete(`*${apiRoutes.creativeSwitchInLeftImage(':id')}`, () => {
    return HttpResponse.json();
  }),
  http.delete(`*${apiRoutes.creativeSwitchInBottomImage(':id')}`, () => {
    return HttpResponse.json();
  }),
  // Video creative upload endpoints
  http.get(`*${apiRoutes.creativeVideoUploadParams(':id')}`, () => {
    return HttpResponse.json({
      fileStorageId: 'test-file-storage-id-123',
      url: 'https://test-storage.example.com/upload',
      fields: {
        key: 'test-key',
        policy: 'test-policy',
        signature: 'test-signature',
      },
    });
  }),
  http.post('https://test-storage.example.com/upload', () => {
    return new HttpResponse(null, { status: 204 });
  }),
  http.put(`*${apiRoutes.creativeVideoSpot(':id')}`, () => {
    return HttpResponse.json({
      fileStorageId: 'test-file-storage-id-123',
      originalFileName: 'test-video.mp4',
      status: DataStatuses.IN_APPROVAL,
      url: 'https://test-storage.example.com/test-video.mp4',
    });
  }),
  http.delete(`*${apiRoutes.creativeVideoSpot(':id')}`, () => {
    return HttpResponse.json();
  }),
];
